import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentFuelFilterId } from '../../store/geoentity/fuels.selectors'
import { getColorFromOpeningStatus } from '../../store/geoentity/geoentity.helpers'
import { selectGeolocationPosition, selectIsGeoLocationOn } from '../../store/geolocation/geolocation.selectors'
import { selectSubCategoryById } from '../../store/poiassets/poiassets.selectors'
import { isPE } from '../Device'
import GeoentityItemThumbnail from '../genericComponents/GeoentityItemThumbnail'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import SVGIcon from '../svg/SVGIcon'
import { getDistanceByFlyCrow } from '../utils/map'
import { useSelectorWithProps } from '../utils/react-redux'
import CornerShops from './CornerShops'
import GeoentityFuelCards from './GeoentityFuelCards'
import sFuelListItem from './GeoentityFuelListItem.less'
import sListItem from './GeoentityListItem.less'
import GeoentityOpeningMessage from './GeoentityOpeningMessage'
import GoToGeoentityButton from './GoToGeoentityButton'
import Reviews from './Reviews'
import PromoIcon from './promo.svg'
import useGeoentityListItem from './useGeoentityListItem'

const GeoentityFuelListItem = ({ poi, noExternalButtons, seoHideImages }) => {
  const { name, rubric = {}, cornerShops, additionalInfo = {}, addressLabel, reviews, openingStatus, coordinates } = poi
  const { secondTeasing, promo, fuels } = additionalInfo
  const illustrationUrl = additionalInfo?.illustration?.url
  const { label: rubricLabel } = rubric

  const currentFuelId = useSelector(selectCurrentFuelFilterId)
  const isGeolocationActive = useSelector(selectIsGeoLocationOn)
  const currentPosition = useSelector(selectGeolocationPosition)
  const poiDistance = currentPosition?.lng
    ? getDistanceByFlyCrow(currentPosition?.lng, currentPosition?.lat, coordinates.lng, coordinates.lat)
    : null

  const { displayOptions, liMouseListeners, isSelected, geoentityImageAlt } = useGeoentityListItem(poi)

  const { message: openingMessage, status } = openingStatus ?? {}
  const openingMessageColor = getColorFromOpeningStatus(status)
  const gasStationColor = useSelectorWithProps(selectSubCategoryById, { id: 'station-service' })
  const matchingFuel = fuels?.find(fuel => fuel?.id === currentFuelId)

  return (
    <li className={classNames(sListItem.item, isSelected && sListItem.selectedItem)} {...liMouseListeners}>
      <div className={classNames(sListItem.content, sFuelListItem.fuelContent)}>
        {isPE() && __BROWSER__ && (
          <div className={sFuelListItem.fuelHeader}>
            <div className={sFuelListItem.geoentityLogo} style={{ backgroundColor: gasStationColor?.color }}>
              <SVGIcon className={sFuelListItem.gasStationIcon} icon={'station-service'} />
            </div>
            {isGeolocationActive && poiDistance >= 0 && (
              <div className={sFuelListItem.geoentityDistance}>{`à ${poiDistance?.toFixed(1)} km`}</div>
            )}
          </div>
        )}
        <div className={sFuelListItem.fuelTextualContent}>
          <div className={sListItem.name}>
            <GoToGeoentityButton poi={poi} className={sListItem.link} isLink>
              {name}
            </GoToGeoentityButton>
            {promo && (
              <div className={sListItem.promo}>
                <img src={PromoIcon} alt="Promo icône" /> Promo
              </div>
            )}
          </div>
          {displayOptions.address && <div className={sListItem.text}>{addressLabel}</div>}
          {displayOptions.rubric && <div className={sListItem.text}>{rubricLabel}</div>}
          <div className={sListItem.text}>
            <Reviews reviews={reviews} />
          </div>
          <div className={sListItem.text} dangerouslySetInnerHTML={{ __html: secondTeasing }} />
          <GeoentityOpeningMessage openingMessage={openingMessage} openingMessageColor={openingMessageColor} />
          <CornerShops cornerShops={cornerShops} />
          {matchingFuel && <GeoentityFuelCards poi={poi} />}
          <div className={sListItem.button}>
            <GoToGeoentityButton poi={poi} tagInfo={{ bouton_clique: "Plus d'infos" }}>
              <RectangleActionButton
                label="Plus d'infos"
                color={COLOR_GREY_EMPTY}
                className={noExternalButtons ? sListItem.fakeButtonLandingPage : sListItem.buttonMoreInfo}
                size={SIZE_MEDIUM}
              />
            </GoToGeoentityButton>
          </div>
        </div>
      </div>
      <GeoentityItemThumbnail className={sListItem.illustration} src={illustrationUrl} alt={geoentityImageAlt} seoHideImage={seoHideImages} />
    </li>
  )
}

export default GeoentityFuelListItem
